import OmniSearchBar from "../../omni-common/components/OmniSearchBar";
import OmniSelectBox from "../../omni-common/components/OmniSelectBox";

interface DateRange {
  startDate?: string;
  endDate?: string;
}

interface DraftSearchFiltersProps {
  searchQuery: string;
  onSearchChange: (value: string) => void;
  onSearch: () => void;
  searchType: string;
  onSearchTypeChange: (value: string) => void;
  statusFilter: string;
  onStatusChange: (value: string) => void;
  dateTypeFilter: string;
  onDateTypeChange: (value: string) => void;
  dateRange: DateRange;
  onDateRangeChange: (range: DateRange) => void;
  onDatePresetSelect: (preset: string) => void;
  selectedDatePreset?: string;
  onReset: () => void;
}

const SEARCH_TYPE_OPTIONS = [
  { label: "전체", value: "ALL" },
  { label: "제목", value: "TITLE" },
  { label: "태그", value: "TAG" },
  { label: "내용+태그", value: "CONTENT_TAG" },
];

const STATUS_OPTIONS = [
  { label: "전체", value: "" },
  { label: "초안", value: "NEW" },
  { label: "검토중", value: "EDITING" },
  { label: "승인", value: "APPROVED" },
];

const DATE_PRESETS = [
  { label: "전체", value: "ALL" },
  { label: "오늘", value: "TODAY" },
  { label: "3일", value: "3DAYS" },
  { label: "7일", value: "7DAYS" },
  { label: "1개월", value: "1MONTH" },
  { label: "6개월", value: "6MONTHS" },
  { label: "1년", value: "1YEAR" },
  { label: "직접선택", value: "CUSTOM" },
];

export default function DraftSearchFilters({
  searchQuery,
  onSearchChange,
  onSearch,
  searchType,
  onSearchTypeChange,
  statusFilter,
  onStatusChange,
  dateTypeFilter,
  onDateTypeChange,
  dateRange,
  onDateRangeChange,
  onDatePresetSelect,
  selectedDatePreset = "ALL",
  onReset,
}: DraftSearchFiltersProps) {
  return (
    <div className="flex flex-col gap-4 rounded-lg bg-white p-6 shadow-md">
      <div className="flex items-center justify-between gap-4">
        <div className="flex items-center gap-2 flex-1">
          <OmniSelectBox
            value={searchType}
            onSelect={onSearchTypeChange}
            options={SEARCH_TYPE_OPTIONS}
            className="min-w-[120px]"
          />
          <OmniSearchBar
            value={searchQuery}
            onChange={onSearchChange}
            onSearch={onSearch}
            placeholder="검색어를 입력하세요..."
          />
        </div>
        <div className="flex items-center gap-2">
          <button
            onClick={onReset}
            className="whitespace-nowrap rounded bg-black px-4 h-[40px] text-sm font-medium text-white transition-colors hover:bg-gray-800"
          >
            초기화
          </button>
        </div>
      </div>
      
      <div className="flex flex-wrap items-center gap-4">
        <div className="flex items-center gap-2">
          <span className="text-sm font-medium text-gray-700">상태:</span>
          <OmniSelectBox
            value={statusFilter}
            onSelect={onStatusChange}
            options={STATUS_OPTIONS}
            className="min-w-[120px]"
          />
        </div>

        <div className="flex items-center gap-2">
          <span className="text-sm font-medium text-gray-700">기간:</span>
          <div className="flex gap-2">
            {DATE_PRESETS.map((preset) => {
              const isSelected = selectedDatePreset === preset.value;
              return (
                <button
                  key={preset.value}
                  onClick={() => onDatePresetSelect(preset.value)}
                  className={`rounded px-3 h-[40px] text-sm font-medium transition-colors ${
                    isSelected
                      ? "bg-blue-500 text-white"
                      : "bg-gray-100 text-gray-700 hover:bg-gray-200"
                  }`}
                >
                  {preset.label}
                </button>
              );
            })}
          </div>
        </div>
        
        {selectedDatePreset === "CUSTOM" && (
          <div className="flex items-center gap-2 rounded border border-gray-300 px-3 h-[40px]">
            <input
              type="date"
              value={dateRange.startDate || ""}
              onChange={(e) => {
                onDateRangeChange({ ...dateRange, startDate: e.target.value });
              }}
              className="border-none outline-none text-sm bg-transparent"
            />
            <span className="text-gray-500">~</span>
            <input
              type="date"
              value={dateRange.endDate || ""}
              onChange={(e) => {
                onDateRangeChange({ ...dateRange, endDate: e.target.value });
              }}
              className="border-none outline-none text-sm bg-transparent"
            />
          </div>
        )}
      </div>
    </div>
  );
}